import {System} from '../System';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
// import {tap} from 'rxjs/operatorsObjects';
import {CourseSearchModel} from './course-search.model';
import {CourseSearchCriteria} from './course-search-criteria';

@Injectable()
export class CourseSearchService {
    unsavedQueryApplied: boolean;

    constructor(private http: HttpClient) {
    }

    getCourseCatalog(
        schoolId,
        aYidentifier,
        courseIdentier = '',
        courseName = '',
        subjectArea = '',
        creditCode = '',
        districtWide = false,
        siteYear_ID = -1,
        termType = ''
    ): Observable<any[]> {
        const queryString = '?aYidentifier=' + aYidentifier +
            '&subjectArea=' + subjectArea +
            '&creditCode=' + creditCode +
            '&schoolDomain=' + schoolId +
            '&districtWide=' + districtWide +
            '&siteYear_ID=' + siteYear_ID +
            '&courseName=' + courseName +
            '&courseIdentifier=' + courseIdentier +
            '&termType=' + termType;
        return this.http.get<CourseSearchModel[]>(
            System.apiURL.Student +
            'GetCourseList' +
            queryString
        ); // .pipe(tap(data => console.log('course: ' + JSON.stringify(data))));
    }

    getUserPreferences(studentId, pageURL, subjectListId?, subjectSection?, isDefaultPreferences?): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Student + `GetUserPreferences?studentId=${studentId}&pageURL=${pageURL}&subjectListId=${subjectListId}&subjectSection=${subjectSection}&isDefaultPreferences=${isDefaultPreferences}`);
    }

    saveUserPreferences(studentId, pageURL, data, subjectListId?, subjectSection?, isDefaultPreferences?) {
        return this.http.post<any[]>(System.apiURL.Student + `SaveUserPreferences?studentId=${studentId}&pageURL=${pageURL}&subjectListId=${subjectListId}&subjectSection=${subjectSection}&isDefaultPreferences=${isDefaultPreferences}`, data);
    }
}
